export default {
  'app.setting.pagestyle': 'Настройка стиля страницы',
  'app.setting.pagestyle.dark': 'Темный стиль',
  'app.setting.pagestyle.light': 'Светлый стиль',
  'app.setting.content-width': 'Ширина контента',
  'app.setting.content-width.fixed': 'Фиксированная',
  'app.setting.content-width.fluid': 'Гибкая',
  'app.setting.themecolor': 'Цвет темы',
  'app.setting.themecolor.dust': 'Пыльно-красный',
  'app.setting.themecolor.volcano': 'Вулкан',
  'app.setting.themecolor.sunset': 'Закатный оранжевый',
  'app.setting.themecolor.cyan': 'Голубой',
  'app.setting.themecolor.green': 'Полярный зеленый',
  'app.setting.themecolor.daybreak': 'Синий рассвет (по умолчанию)',
  'app.setting.themecolor.geekblue': 'Гик-синий',
  'app.setting.themecolor.purple': 'Золотисто-фиолетовый',
  'app.setting.navigationmode': 'Режим навигации',
  'app.setting.sidemenu': 'Макет бокового меню',
  'app.setting.topmenu': 'Макет верхнего меню',
  'app.setting.fixedheader': 'Фиксированный заголовок',
  'app.setting.fixedsidebar': 'Фиксированная боковая панель',
  'app.setting.fixedsidebar.hint': 'Работает с макетом бокового меню',
  'app.setting.hideheader': 'Скрытый заголовок при прокрутке',
  'app.setting.hideheader.hint': 'Работает когда включен скрытый заголовок',
  'app.setting.othersettings': 'Другие настройки',
  'app.setting.weakmode': 'Режим для дальтоников',
  'app.setting.copy': 'Копировать настройки',
  'app.setting.copyinfo':
    'копирование успешно, замените defaultSettings в src/models/setting.js',
  'app.setting.production.hint':
    'Панель настроек отображается только в среде разработки, измените вручную',
};
